import React from "react";
import {
  RecBar,
  RecIcon,
  RecStat,
  RecStatusPill,
  RecThumb,
  RecTypePill,
} from "./MaterialRecordParts";
import {
  costLabel,
  formatClientPrice,
  formatCost,
  formatStock,
  isServiceType,
  usesInventory,
} from "./materialRecordModel";

/**
 * VIEW MODE: information first, compact, scannable. Shows only what exists
 * today (identity, cost/rate, unit, stock, SKU, description).
 */
export function MaterialDetails({
  material,
  canEdit,
  canViewPricing,
  onBack,
  onEdit,
  imageUrl,
  notice = "",
}) {
  const type = material.material_type;
  const showStock = canViewPricing && usesInventory(type);
  const sku = material.sku || "—";
  const unit = material.unit_of_measure || "—";
  const description = String(material.description || "").trim();

  return (
    <div className="screen nx-screen rec-page rec-page--detail" data-testid="material-details">
      <RecBar title={isServiceType(type) ? "Service Details" : "Material Details"} onBack={onBack} />

      <div className="rec-body">
        {notice ? (
          <div className="rec-banner" role="alert">
            {notice}
          </div>
        ) : null}
        <section className="rec-card rec-identity">
          <RecThumb name={material.material_name} type={type} imageUrl={imageUrl} />
          <div className="rec-identity__text">
            <h2 className="rec-identity__name">{material.material_name}</h2>
            <div className="rec-pills">
              <RecTypePill type={type} />
              <RecStatusPill active={material.active !== false} />
            </div>
          </div>
        </section>

        <section className="rec-card rec-stats" aria-label="Details">
          {canViewPricing ? (
            <RecStat icon="tag" label={isServiceType(type) ? costLabel(type) : "Our cost"} value={formatCost(material)} hero />
          ) : null}
          {canViewPricing && !isServiceType(type) && formatClientPrice(material) != null ? (
            <RecStat icon="tag" label="Client price" value={formatClientPrice(material)} />
          ) : null}
          <RecStat icon="cube" label="Unit of Measure" value={unit} />
          {showStock ? (
            <RecStat icon="box" label="Current Inventory" value={formatStock(material)} />
          ) : null}
          <RecStat icon="barcode" label="SKU" value={sku} wide={!showStock && canViewPricing} />
        </section>

        {description ? (
          <section className="rec-card rec-desc">
            <div className="rec-label">
              <RecIcon name="doc" />
              Description
            </div>
            <p className="rec-desc__text">{description}</p>
          </section>
        ) : null}
      </div>

      {canEdit ? (
        <div className="rec-actions">
          <button type="button" className="rec-btn rec-btn--outline" onClick={onEdit}>
            <RecIcon name="pencil" />
            Edit
          </button>
        </div>
      ) : null}
    </div>
  );
}
